import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';

const CustomLink = ({ text, path } ) => {
  const themeContext = useContext(ThemeContext);
  const StyledLink = styled(Link)`
    text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;
  const StyledSpan = styled.span`
color: ${themeContext.buttons.backGroundColor.primaryColor};
`;
  return (
    <React.Fragment>
      <StyledLink to={path}>
        <StyledSpan>
          {<FormattedMessage id={text} />}
        </StyledSpan>
      </StyledLink>
    </React.Fragment>
  );
};

CustomLink.propTypes = {
  text: PropTypes.string,
  path: PropTypes.string,
};

export default CustomLink;
